// extracted by mini-css-extract-plugin
module.exports = {"block__padding":"block-padding_block__padding__fR_UE","inner":"block-padding_inner__QybIU"};